<template>
	<div class="order-search-body">
		<div class="filters-box-row">
			<div class="filters-container">
				<div class="input-box">
					<span>时间：</span>
					<el-date-picker
						v-model="dateValue"
						:clearable="false"
						:unlink-panels='true'
						:default-time="['00:00:00', '23:59:59']"
						class="time-input"
						size="small"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm'>
					</el-date-picker>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>付款方/客户：</span>
					<el-input
						v-model="customerName"
						placeholder="请输入付款方/客户"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>流水号/单据号：</span>
					<el-input
						class="search-input"
						v-model="searchNumber"
						placeholder="请输入流水号/单据号"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>店铺名称：</span>
					<el-select class="filter-input" size='mini' v-model="shopId" clearable>
						<el-option v-for="item in shopList" :value="item.id" :label="item.name" :key="item.id">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="filters-container" style="position:relative">
				<el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
				</el-button>
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="filters-box-row filters-box-row2">
			<div class="filters-container" v-show="!collapse">
				<div class="input-box">
					<span>类型：</span>
					<el-select v-model="type" class="filter-input" size='small'>
						<el-option value="" label="全部"></el-option>
						<el-option value="0" label="充值"></el-option>
						<el-option value="1" label="订单扣减"></el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div class="filters-box-row filters-box-row3">
			<el-button size="small" type="primary" plain class="btn fx-btn" style="margin-left:0" v-if="AuthorityList['01_0009_0002_00']" @click="goRecharge">充值</el-button>
			<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" @click="exportExcel">
				<div></div>
				导出
			</el-button>
		</div>
		<el-dialog title="微企付充值" class="dialog-title" @close="wqfClose" :visible.sync="rechargeModal" width='550px' :close-on-click-modal="false">
			<div class="reason-box">
				<span class="wqf-title">选择店铺:</span>
				<el-select class="input-width" size='mini' v-model="codeshopId" @change="shopChange">
					<el-option v-for="item in shopList" :value="item.id" :label="item.name" :key="item.id">
					</el-option>
				</el-select>
				<div class="balance-wrap" v-if="freeMoney || lockMoney">可用余额:{{freeMoney}}元 &nbsp;&nbsp;已锁定金额:{{lockMoney}}元</div>
            </div>
			<div class="reason-box">
				<span class="wqf-title">充值金额:</span>
                <el-input class="input-width" @input="moneyInput" size='mini' v-model="rechargeMoney"></el-input>
            </div>
			<div class="reason-box">
				<span class="wqf-title">备注:</span>
                <el-input class="input-width" size='mini' v-model="memo"></el-input>
            </div>
			<div class="wqf-description">
				<div>说明:</div>
				<div>1.平台费率按{{deductRatio}}‰进行收取；</div>
				<div>2.每次选择一个店铺进行充值，该店铺为营业中的店铺；</div>
				<div>3.使用微企付支付的单据发生退款、订单取消时平台已收费率不退回；</div>
				<div>4.订单扣减金额不足0.01元时均按0.01进行扣减</div>
			</div>
			<div>
				<div class="title-btn-box">
					<el-button class="btn" plain type="primary" size='small' @click="rechargeClose">取消</el-button>
					<el-button class="btn" type="primary" size='small' @click="rechargeSave">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="微企付充值" class="dialog-title" :visible.sync="codeModal" width='550px' @close="closeClear" :close-on-click-modal="false">
			<w-image :src="codeUrl" style="margin:0 auto"></w-image>
			<div style="text-align:center">
				<el-button class="btn" plain type="primary" size='small' @click="codeClose">返回</el-button>
				<el-button class="btn" type="primary" size='small' @click="codeSuccess">我已支付成功</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'search',
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		customList: {
			type: Array,
			default: () => []
		},
		staffList: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			deductRatio: '',
			dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59'],
			collapse: false,
			dateType: 0,
			customerCategoryId: '0',
			number: '',
			staff: [],
			liquiDateFlag: -1,
			customer: '',
			product: '',
			spec: '',
			rechargeModal: false,
			rechargeMoney: '',
			memo: '',
			shopList: [],
			shopId: '',
			codeModal: false,
			codeUrl: '',
			codeshopId: '',
			customerName: '',
			searchNumber: '',
			type: '',
			freeMoney: '',
			lockMoney: ''
		}
	},
	created () {
		this.getShopList()
		this.getDeductRatio()
	},
	methods: {
		getDeductRatio () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/order/tenpay/payment/deductRatio`
			}).then(res => {
				if (res.result) {
					this.deductRatio = res.data
				}
			})
		},
		wqfClose () {
			this.codeshopId = ''
			this.rechargeMoney = ''
			this.memo = ''
			this.freeMoney = ''
			this.lockMoney = ''
		},
		shopChange (e) {
			let params = {
				shopId: e
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/tenpay/payment/freeMoney`,
				data: params
			}).then(res => {
				if (res.result) {
					this.freeMoney = this.$fxUtils.toFixedSHW(res.data.freeMoney, 2)
					this.lockMoney = this.$fxUtils.toFixedSHW(res.data.lockMoney, 2)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		closeClear () {
			this.codeshopId = ''
			this.rechargeMoney = ''
			this.memo = ''
		},
		codeClose () {
			this.codeModal = false
		},
		codeSuccess () {
			this.codeModal = false
			this.search()
		},
		goRecharge () {
			this.rechargeModal = true
		},
		rechargeClose () {
			this.rechargeModal = false
		},
		rechargeSave () {
			if (!this.codeshopId) {
				this.$message.error('请选择店铺！')
				return false
			}
			if (!this.rechargeMoney) {
				this.$message.error('请输入充值金额！')
				return false
			}
			let params = {
				shopId: this.codeshopId,
				amount: this.rechargeMoney,
				memo: this.memo
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/tenpay/topup`,
				data: params
			}).then(res => {
				if (res.result) {
					this.codeUrl = 'data:image/png;base64,' + res.data.code_base64
					this.rechargeModal = false
					this.codeModal = true
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		moneyInput () {
			this.rechargeMoney = this.rechargeMoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.rechargeMoney = this.rechargeMoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.rechargeMoney = this.rechargeMoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.rechargeMoney = this.rechargeMoney.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.rechargeMoney = this.rechargeMoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入一个小数
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			})
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		search () {
			this.dateValue = this.dateValue === null ? [] : this.dateValue
			this.$emit('handleSearch', { customerName: this.customerName, searchNumber: this.searchNumber, type: this.type, dateValue: this.dateValue, shopId: this.shopId })
		},
		// 导出
		exportExcel () {
			this.$emit('exportExcel')
		},
		clear () {
			// let value = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			// this.searchTime(value)
			this.clearAllInput()
			this.search()
		},
		clearAllInput () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.customerName = ''
			this.searchNumber = ''
			this.type = ''
			this.shopId = ''
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-search-body {
	.filters-box-row {
		display: flex;
		padding: 10px 0 0 0;
		width :100%;
		line-height :50px;
		min-width :600px;
		box-sizing: border-box
		text-align: left
		.select-input {
			width: 125px!important;
		}
		&.filters-box-row2 {
			padding-top: 0;
			.filters-container {
				display: flex
				flex-wrap: wrap
				.input-box {
					margin-right: 5px
				}
			}
		}
		&.filters-box-row3 {
			padding-top: 5px;
			height: 50px
		}
		.filters-container {
			margin-right: 5px
			.el-input {
				width: 155px
			}
			.time-input {
				width: 310px;
			}
			.filter-input {
				width: 155px
			}
			.excel-icon {
				display inline-block
				height 20px
				width 20px
				background-repeat no-repeat
				background-position center
				vertical-align: sub;
				&.import-excel-icon {
					background-image: url('~images/icon/import-excel-icon.png')
				}
				&.export-excel-icon {
					background-image: url('~images/icon/export-excel-icon.png')
				}
			}
		}
	}
	.input-width {
		width: 200px
	}
	.balance-wrap {
		padding-left: 118px
		margin: 5px 0;
		color: red;
	}
	.wqf-title {
		width: 105px;
		text-align: right;
		display: inline-block;
		margin-right: 10px;
		line-height: 40px;
	}
	.wqf-description {
		color: red;
		padding-left: 73px
		margin: 20px 0
	}
	.title-btn-box{
		height:40px;
		padding:10px;
		box-sizing:border-box;
		text-align:right
	}
}
</style>
<style lang="stylus">
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.input-tel input{
		-webkit-appearance: none;
		-webkit-box-sizing: content-box;
		font-family: inherit;
		font-size: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
</style>
